import { get, post } from "@/utils/request";
import type { Recall, CommonForm, Detail } from "@/types/procss";
import type { Response } from "@/types/axios";

//员工调动申请
export const startEmployeeTransferApply = (params: {
  RegionID?: number;
  List?: {
    RegionName?: string;
    TransferStaffID?: number;
    TransferStaffName?: string;
    SignInLastDate?: string;
  }[];
}): Promise<Response<Detail>> =>
  post("/api/employeeTransfer/startEmployeeTransferApply", params);

//获取员工调动申请
export const getEmployeeTransferApply = (params: {
  BranchCompanyFlowId: number | string;
}): Promise<Response<Detail>> =>
  post("/api/employeeTransfer/getEmployeeTransferApply", params);

//人选转移详情
export const getBusinessApplyFirstInfo = (params: {
  BranchCompanyFlowId: number | string;
}): Promise<Response<Detail>> =>
  post("/api/employeeTransfer/getBusinessApplyFirstInfo", params);

//人选转移申请
export const startCustomerTransferApply = (
  params: CommonForm
): Promise<Response<Detail>> =>
  post("/api/employeeTransfer/startCustomerTransferApply", params);
